const WORDS = [
  "Redensyl",
  "Argan Oil",
  "Ginseng Root",
  "Peptides",
  "AnaGain",
  "Piroctone Olamine",
  "Matricaria",
  "Vitamin E",
];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <section className="bg-obsidian text-cream py-8 overflow-hidden relative grain" data-testid="marquee">
      <div className="relative z-10 flex whitespace-nowrap animate-marquee">
        {row.map((w, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-serif text-3xl md:text-5xl italic px-8">{w}</span>
            <span className="text-amber text-2xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
